import React from 'react';
import {  useQuery, Loading, loaded, Error, SelectInput, required } from 'react-admin';
import jwt_decode from 'jwt-decode'


const Trainings = ({rest,...props }) => {
    let cid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).cid : '1'    
    //console.log(cid)
    const { data, loading,loaded, error } = useQuery({ 
        type: 'getOne',
        resource: 'trainingchoiceset',
        payload: { id: cid }
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    console.log(data)
    let choiceSet = [];
    var trainings = (data.trainings)? JSON.parse(data.trainings): null;

    trainings.map((item, index) => {
        item.isActive && choiceSet.push(
            {
                id : item['name'] ,
                name: item['name'],
            }
        )

    })

    
    if (!loaded) return null;
    return (
        <div>
            <SelectInput
                    source="training_name"
                    choices={choiceSet} 
                    label = 'Training'
                    validate={required()}
                 {...rest}
            />
        </div>
    );
};

export default Trainings